import { Component, computed, input, ChangeDetectionStrategy } from '@angular/core';

export type IconName = 'password' | 'email' | 'telegram' | 'phone' | 'sms' | 'facebook' | 'google' | 'close' | 'edit'
  | 'check-circle' | 'map' | 'search' | 'trash' | 'ellipsis' | 'heart' | 'heart-filled' | 'cart' | 'cart-filled'
  | 'filter' | 'chevron-down' | 'chevron-right' | 'copy' | 'check' | 'catalog' | 'arrow-left' | 'orders'
  | 'card' | 'bank' | 'repeat' | 'external-link' | 'cash';

const buildIconId = (name: IconName): string => {
  return `tc-icon-${name}`;
};

@Component({
  selector: 'tc-icon-sprite',
  imports: [],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './icon-sprite.component.html',
})
export class IconSpriteComponent {
  buildIconId = buildIconId;
}



@Component({
  selector: 'tc-icon',
  imports: [],
  template: `
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <use [attr.href]="iconUrl()" />
    </svg>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [`
    :host {
      display: inline-flex;
      width: 22px;
      height: 22px; /* height is needed to be computed height as predictable as possible. Had issues on iOS. */
      flex: 0 0 auto;
    }

    svg {
      width: 100%;
      height: 100%;
      display: block;
      flex: 0 0 auto;
    }
  `],
})
export class IconComponent {
  name = input.required<IconName>();

  iconUrl = computed(() => `#${buildIconId(this.name())}`);
}
